module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_Black_MockedUp.15ee7b66.jpg";